(() => {
  const mobile = matchMedia('(max-width:749px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const en = document.documentElement.lang.startsWith('en');
  const t = (fr, english) => en ? english : fr;
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };
  document.querySelector('.section-header')?.classList.add('ic-mobile-header-sticky');
  const main = document.querySelector('product-info[id^="MainProduct-"]');
  if (main) {
    const bar = make('div','ic-mobile-buy');
    bar.hidden = true;
    bar.setAttribute('role','region');
    bar.setAttribute('aria-label',t('Achat rapide','Quick purchase'));
    const price = make('span','ic-mobile-buy__price');
    const button = make('button','ic-mobile-buy__button');
    button.type = 'button';
    bar.append(price,button);
    document.body.append(bar);
    let native;
    let nativeVisible = false;
    let lastError = '';
    const observer = new IntersectionObserver(entries => {
      nativeVisible = entries[0].isIntersecting;
      update();
    },{threshold:0});
    const update = () => {
      const current = main.querySelector('product-form button[name="add"]');
      if (current !== native) {
        if (native) observer.unobserve(native);
        native = current;
        if (native) observer.observe(native);
      }
      if (!native) { bar.hidden = true; return; }
      const money = main.querySelector('.price--on-sale .price-item--sale') || main.querySelector('.price__regular .price-item--regular');
      price.textContent = money?.textContent.trim() || '';
      button.textContent = native.querySelector('span')?.textContent.trim() || native.textContent.trim();
      button.disabled = native.disabled || native.getAttribute('aria-disabled') === 'true' || native.classList.contains('loading');
      bar.hidden = !mobile.matches || nativeVisible;
      document.body.classList.toggle('ic-has-mobile-buy',mobile.matches);
      const secondary = document.querySelector('.ic-cal3d__ctabtn');
      if (secondary) { secondary.textContent = button.textContent; secondary.disabled = button.disabled; }
      const error = main.querySelector('.product-form__error-message-wrapper:not([hidden])');
      const errorText = error?.textContent.trim() || '';
      if (mobile.matches && errorText && errorText !== lastError) error.scrollIntoView({block:'center',behavior:reduced.matches ? 'instant' : 'smooth'});
      lastError = errorText;
    };
    button.addEventListener('click',() => {
      if (!native || button.disabled) return;
      native.click();
      update();
    });
    new MutationObserver(update).observe(main,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
    mobile.addEventListener('change',update);
    update();
    const jumps = make('nav','ic-mobile-jumps');
    jumps.setAttribute('aria-label',t('Sur cette fiche produit','On this product page'));
    [['.ic-book,.ic-cal',t('Découvrir','Explore')],['.ic-steps',t('Règles du jeu','How to play')],['.ic-specs',t('En bref','At a glance')],['.ic-faq',t('Questions','Questions')],['#looxReviews',t('Avis','Reviews')]].forEach(([selector,label],i) => {
      const target = document.querySelector(selector);
      if (!target) return;
      if (!target.id) target.id = `ic-mobile-section-${i}`;
      target.classList.add('ic-mobile-target');
      const link = make('a','',label);
      link.href = `#${target.id}`;
      link.addEventListener('click',() => {
        const details = target.querySelector('.ic-mobile-fold');
        if (details) details.open = true;
      });
      jumps.append(link);
    });
    main.querySelector('.product__info-container')?.append(jumps);
  }
  document.querySelectorAll('.footer-block').forEach((block,i) => {
    const heading = block.querySelector('.footer-block__heading');
    const list = block.querySelector('.footer-block__details-content');
    if (!heading || !list || !list.querySelector('a')) return;
    block.classList.add('ic-footer-collapsible');
    const original = Array.from(heading.childNodes);
    const toggle = make('button','ic-footer-toggle');
    toggle.type = 'button';
    list.id ||= `ic-footer-links-${i}`;
    toggle.setAttribute('aria-controls',list.id);
    const update = () => {
      if (mobile.matches) {
        original.forEach(node => toggle.append(node));
        heading.replaceChildren(toggle);
        toggle.setAttribute('aria-expanded','false');
        list.hidden = true;
      } else {
        heading.replaceChildren(...original);
        list.hidden = false;
      }
    };
    toggle.addEventListener('click',() => {
      list.hidden = !list.hidden;
      toggle.setAttribute('aria-expanded',String(!list.hidden));
    });
    mobile.addEventListener('change',update);
    update();
  });
  if (main) document.querySelectorAll('.ic-steps').forEach(section => {
    const title = section.querySelector('h2');
    if (!title) return;
    const content = Array.from(section.children);
    const details = make('details','ic-mobile-fold');
    const summary = make('summary','',title.textContent.trim());
    const body = make('div','ic-mobile-fold__body');
    details.append(summary,body);
    const update = () => {
      if (mobile.matches) {
        content.forEach(node => body.append(node));
        section.append(details);
      } else {
        content.forEach(node => section.append(node));
        details.remove();
      }
    };
    mobile.addEventListener('change',update);
    update();
  });
  if (typeof HTMLDialogElement === 'undefined') return;
  document.querySelectorAll('[data-book],[data-calendar-flip]').forEach((viewer,i) => {
    const isBook = viewer.matches('[data-book]');
    const opener = make('button','ic-mobile-expand',isBook ? t('Agrandir et écouter','Enlarge and listen') : t('Ouvrir en plein écran','Open full screen'));
    opener.type = 'button';
    opener.setAttribute('aria-haspopup','dialog');
    viewer.before(opener);
    opener.addEventListener('click',() => {
      const dialog = make('dialog','ic-mobile-dialog');
      const toolbar = make('div','ic-mobile-dialog__bar');
      const title = make('h2','',isBook ? t('Lire et écouter','Read and listen') : t('Mon calendrier 3D','My 3D calendar'));
      title.id = `ic-mobile-viewer-title-${i}`;
      dialog.setAttribute('aria-labelledby',title.id);
      const close = make('button','ic-mobile-close',t('Fermer','Close'));
      close.type = 'button';
      toolbar.append(title,close);
      const body = make('div','ic-mobile-dialog__body');
      const marker = document.createComment('viewer-position');
      viewer.before(marker);
      body.append(viewer);
      dialog.append(toolbar,body);
      document.body.append(dialog);
      let restoreBook;
      if (isBook) {
        const spread = viewer.querySelector('.ic-book__spread');
        const spreadImage = spread.querySelector('img');
        const originalSizes = spreadImage.getAttribute('sizes');
        const holder = make('div','ic-mobile-book-scroll');
        const zoom = make('div','ic-mobile-zoom');
        const minus = make('button','', '−');
        const plus = make('button','', '+');
        const value = make('output','', '100%');
        minus.type = plus.type = 'button';
        minus.setAttribute('aria-label',t('Réduire','Zoom out'));
        plus.setAttribute('aria-label',t('Agrandir','Zoom in'));
        value.setAttribute('aria-live','polite');
        zoom.append(minus,value,plus);
        body.prepend(zoom);
        spread.before(holder);
        holder.append(spread);
        let scale = 1;
        const setZoom = step => {
          scale = Math.max(1,Math.min(3,scale + step));
          spread.style.width = `${scale * 100}%`;
          spreadImage.sizes = `${Math.ceil((Math.max(dialog.clientWidth,document.documentElement.clientWidth) - 40) * scale)}px`;
          value.textContent = `${Math.round(scale * 100)}%`;
          minus.disabled = scale === 1;
          plus.disabled = scale === 3;
        };
        setZoom(0);
        minus.addEventListener('click',() => setZoom(-.5));
        plus.addEventListener('click',() => setZoom(.5));
        restoreBook = () => {
          holder.before(spread);holder.remove();spread.style.removeProperty('width');
          if (originalSizes === null) spreadImage.removeAttribute('sizes');
          else spreadImage.setAttribute('sizes',originalSizes);
        };
      }
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      close.focus();
      window.dispatchEvent(new Event('resize'));
      close.addEventListener('click',() => dialog.close());
      dialog.addEventListener('close',() => {
        restoreBook?.();
        marker.replaceWith(viewer);
        document.body.style.overflow = previousOverflow;
        dialog.remove();
        window.dispatchEvent(new Event('resize'));
        opener.focus({preventScroll:true});
      },{once:true});
    });
  });
})();
